import { useState } from "react";
import { faqs } from "@/mocks/resources";

const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: {
      "@type": "Answer",
      text: f.a,
    },
  })),
};

export default function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="scroll-mt-20 bg-background-100/60 py-14 md:py-20">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-5">
          <div className="lg:col-span-2">
            <span className="text-sm font-medium text-primary-600">常见问题</span>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              你可能想知道的
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              关于失效链接、格式筛选、打包下载、磁力速度与秒传转存等问题，这里都有答案。
              仍有疑问可随时通过下方联系方式反馈。
            </p>
            <div className="mt-5 flex items-center gap-3 rounded-lg border border-primary-200 bg-primary-50 p-4">
              <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-customer-service-2-line text-lg"></i>
              </span>
              <p className="text-sm text-foreground-700">
                需要补档或反馈？
                <button
                  onClick={() => document.getElementById("about")?.scrollIntoView({ behavior: "smooth" })}
                  className="ml-1 font-medium text-primary-600 underline-offset-2 hover:underline"
                >
                  查看联系方式
                </button>
              </p>
            </div>
          </div>

          <div className="lg:col-span-3">
            <div className="divide-y divide-background-200/70 rounded-lg border border-background-200/80 bg-background-50">
              {faqs.map((f, i) => {
                const isOpen = openIndex === i;
                return (
                  <div key={f.q}>
                    <button
                      onClick={() => setOpenIndex(isOpen ? null : i)}
                      aria-expanded={isOpen}
                      className="flex w-full items-center justify-between gap-3 px-4 py-4 text-left"
                    >
                      <span className="text-sm font-semibold text-foreground-900 md:text-base">{f.q}</span>
                      <span
                        className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-background-100 text-foreground-600 transition-transform ${isOpen ? "rotate-45 bg-primary-500 text-background-50" : ""}`}
                      >
                        <i className="ri-add-line text-sm"></i>
                      </span>
                    </button>
                    <div
                      className={`grid transition-all duration-300 ease-in-out ${
                        isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                      }`}
                    >
                      <div className="overflow-hidden">
                        <p className="px-4 pb-4 text-sm leading-relaxed text-foreground-600">{f.a}</p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}